export const openOverlay = (overlayId) => {
  document.getElementById(overlayId).classList.add('open')
}

export const closeOverlay = (overlayId) => {
  document.getElementById(overlayId).classList.remove('open')
}
